/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __extends } from "tslib";
import * as msRest from "@azure/ms-rest-js";
var packageName = "@azure/cognitiveservices-customvision-prediction";
var packageVersion = "5.1.2";
var PredictionAPIClientContext = /** @class */ (function (_super) {
    __extends(PredictionAPIClientContext, _super);
    /**
     * Initializes a new instance of the PredictionAPIClientContext class.
     * @param endpoint Supported Cognitive Services endpoints.
     * @param credentials Subscription credentials which uniquely identify client subscription.
     * @param [options] The parameter options
     */
    function PredictionAPIClientContext(credentials, endpoint, options) {
        var _this = this;
        if (endpoint == undefined) {
            throw new Error("'endpoint' cannot be null.");
        }
        if (credentials == undefined) {
            throw new Error("'credentials' cannot be null.");
        }
        if (!options) {
            options = {};
        }
        if (!options.userAgent) {
            var defaultUserAgent = msRest.getDefaultUserAgentValue();
            options.userAgent = packageName + "/" + packageVersion + " " + defaultUserAgent;
        }
        _this = _super.call(this, credentials, options) || this;
        _this.baseUri = "{Endpoint}/customvision/v3.1/prediction";
        _this.requestContentType = "multipart/form-data";
        _this.endpoint = endpoint;
        _this.credentials = credentials;
        return _this;
    }
    return PredictionAPIClientContext;
}(msRest.ServiceClient));
export { PredictionAPIClientContext };
//# sourceMappingURL=predictionAPIClientContext.js.map